import cookies from "js-cookie";

export const getGuestId = (key = "guest_uid") => cookies.get(key);
